"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asFunctions = exports.param = exports.FunctionBuilder = void 0;
/**
 * Functions - Built in functions accessible from the evaluator context
 */
class FunctionBuilder {
    constructor(name) {
        this.name = name;
        this.params = [];
        this.text = name;
    }
    withText(text) {
        this.text = text;
        return this;
    }
    withDesc(desc) {
        this.desc = desc;
        return this;
    }
    withOutput(output) {
        this.output = output;
        return this;
    }
    withInput(...inputs) {
        this.input = inputs;
        return this;
    }
    withParams(...params) {
        this.params = params;
        return this;
    }
    withFunc(func) {
        this.func = func;
        return this;
    }
    withTag(...tags) {
        this.tag = tags;
        return this;
    }
    build() {
        return {
            name: this.name,
            params: this.params,
            text: this.text,
            desc: this.desc,
            output: this.output,
            input: this.input,
            func: this.func,
            tag: this.tag
        };
    }
}
exports.FunctionBuilder = FunctionBuilder;
const param = (type, text, choices, defaultValue) => {
    let r = {
        type: type,
        text: text
    };
    if (choices) {
        r.choices = choices;
    }
    if (defaultValue !== undefined) {
        r.defaultValue = defaultValue;
    }
    return r;
};
exports.param = param;
const asFunctions = (definitions) => {
    return definitions.reduce((acc, definition) => {
        acc[definition.name] = definition.func;
        return acc;
    }, {});
};
exports.asFunctions = asFunctions;
//# sourceMappingURL=functionDefinition.js.map